import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PetSpeciesFilterableType } from 'src/app/interfaces/pet';
import { User } from 'src/app/interfaces/user';
import { AuthManagerService } from 'src/app/services/auth-manager/auth-manager.service';
import { CheckoutService } from 'src/app/services/checkout/checkout.service';
import { LogService } from 'src/app/services/common/log.service';
import { UserService } from 'src/app/services/user/user.service';
import { HelperService } from 'src/app/shared/helpers/helper.service';
import { environment } from 'src/environments/environment';
import { IdentitableButtonEnum } from '../subscription-tables/desktop/subscription-table-desktop.component';
import { ProductLevel } from '../product-hero/product-hero.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MemberShipOptionsService } from 'src/app/services/membership-options/membership-options.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-identifind-page',
  templateUrl: './identifind-page.component.html',
  styleUrls: ['./identifind-page.component.scss']
})
export class IdentifindPageComponent implements OnInit {

  public pricingPlans = environment.stripePlans;
  public IdentitableButtonEnum = IdentitableButtonEnum;
  public desktopViewVisible: boolean;
  public safeURL: SafeResourceUrl;
  public buyButtonVisible: boolean = true;

  private _subs: Subscription[] = [];
  private user: User;
  private _doesTheUserHaveCat: boolean = false;
  private _doesTheUserHaveDog: boolean = true;
  public productLevels = ProductLevel;
  public hasIdentibasePlusOption: boolean;
  public hasIdentiAlertOption: boolean;
  public hasIdentiFindOption: boolean;
  public isAuthenticated: boolean;
  public isBrowser: boolean;

  constructor(
    private _checkoutService: CheckoutService,
    private _logService: LogService,
    private _router: Router,
    private _helperService: HelperService,
    private _authManager: AuthManagerService,
    private _userService: UserService,
    private _breakpointObserver: BreakpointObserver, 
    private _sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private membershipOptionsService: MemberShipOptionsService,
    private userService: UserService,
    private authManager: AuthManagerService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { 
    const videoURL = "https://www.youtube.com/embed/raia4d-ObFU";
    this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(videoURL);
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit() {
    this.isAuthenticated = this.authManager.isAuthenticated;
    if (this.isAuthenticated) {
      this.userService.getMe().subscribe((userResponse: User) => {
        this.user = userResponse;
        this.hasIdentiFindOption = this.membershipOptionsService.identiFindAvailable(this.user);
        this.hasIdentiAlertOption = this.userService.isUserAlertOrFind(this.user.productType);
      });
    }

    this.handleHeaderElementVisibility();
    if (this._authManager.isAuthenticated) {
      this._userService.getMe().subscribe((userResponse: User) => {
        this.user = userResponse;

        this._doesTheUserHaveCat = !!this.user.pets.find(pet => pet.speciesFilter === PetSpeciesFilterableType.Cat);
        this._doesTheUserHaveDog = !!this.user.pets.find(pet => pet.speciesFilter === PetSpeciesFilterableType.Dog);
      })
    }
    if (this.isBrowser) {
      const currentUrl = window.location.search;
      const params = new URLSearchParams(currentUrl);
      const learnValue = params.get('learn')
      if (learnValue !== null && learnValue.toLowerCase() === 'true') {
        this.buyButtonVisible = false;
      }
    }
  }

  ngOnDestroy() {
    this._subs.forEach(it => it.unsubscribe());
  }

  public compareClick() {
    this._helperService.scrollToElementById('subscription-table');
  }

  public buyIdentiFindSubscription() {
    const planId = this.doesTheUserHaveOnlyCats() ? 
    [this.pricingPlans.identiAlertFindCat] : 
    this.hasIdentiAlertOption ? [this.pricingPlans.pitPatGpsTracker] :
    [this.pricingPlans.identiAlertFind, this.pricingPlans.pitPatGpsTracker];
    this._checkoutService.checkout(planId)
    .subscribe(
      () => {
        // Nothing should happen here because if checkout gets completed successfully, a redirect
        // will be triggered by stripe checkout
      },
      err => {
        this._logService.error('an error occured: ', err);
      }
    )
  }

  public navigateToIdentibasePlusPage() {
    this._router.navigate(['/identibase-plus']);
  }

  public navigateToIdentiAlertPage() {
    this._router.navigate(['/identialert']);
  }

  public onIdentitableButtonClicked(buttonClickedName: string) {
    switch (buttonClickedName) {
      case IdentitableButtonEnum.IdentibasePlusButton:
        this.navigateToIdentibasePlusPage();
        break;
      case IdentitableButtonEnum.IdentialertButton:
        this.navigateToIdentiAlertPage();
        break;
      case IdentitableButtonEnum.IdentifindButton:
        this.buyIdentiFindSubscription();
        break;
    }
  }

  public openFAQPage() {
    if (!this.isBrowser) return;
    window.open('https://identiblog.zendesk.com/hc/en-us/articles/7786017733277-Your-Top-identifind-FAQ-s-Answered-', '_blank');
  }

  private doesTheUserHaveOnlyCats() {
    return this._doesTheUserHaveCat && !this._doesTheUserHaveDog;
  }

  private handleHeaderElementVisibility() {
    this._subs.push(
      this._breakpointObserver
      .observe(['(min-width: 768px)'])
      .subscribe((state: BreakpointState) => {
        this.desktopViewVisible = state.matches;
      })
    );
  }

}
